import { render, staticRenderFns } from "./agreeMent.vue?vue&type=template&id=5369851c&scoped=true&"
import script from "./agreeMent.vue?vue&type=script&lang=js&"
export * from "./agreeMent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369851c",
  null
  
)

export default component.exports